import Fetch from '../fetch/fetch-service';

export function createOrUpdateControl(req, method) {
  return Fetch('/azd/controllerapp/control',
    {
      method,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: JSON.stringify(req),
    });
}

export function createOrUpdateWorkPlan(req, method) {
  return Fetch('/azd/controllerapp/workplan',
    {
      method,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: JSON.stringify(req),
    });
}

export function updateWorkSession(req) {
  return Fetch('/azd/controllerapp/worksession',
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: JSON.stringify(req),
    });
}

export function createReceiptFileUpload(req, filename, contentType, sysId) {
  return Fetch(`/azd/controllerapp/receipt-file-upload?filename=${filename}&content-type=${contentType}&sysid=${sysId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': contentType,
      },
      body: req,
    });
}
